import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list.
 * Extends PaginatedList with support for the `infinite-scroll` attribute.
 * When `infinite-scroll="false"`, the IntersectionObserver is disconnected
 * after setup, disabling automatic page loading on scroll.
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    if (this.getAttribute('infinite-scroll') === 'false') {
      this.infinityScrollObserver?.disconnect();
    }
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
